import { render, staticRenderFns } from "./CompetitionRatingBanner.vue?vue&type=template&id=5774be2e&scoped=true"
import script from "./CompetitionRatingBanner.vue?vue&type=script&lang=js"
export * from "./CompetitionRatingBanner.vue?vue&type=script&lang=js"
import style0 from "./CompetitionRatingBanner.vue?vue&type=style&index=0&id=5774be2e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5774be2e",
  null
  
)

export default component.exports